import React from 'react';

const QuickSearchResultEmpty = ({ result }) => (
    <div
        className="quick-search-result__wrapper"
        id="quick-search-results-wrapper"
    >
        {result.emptyResultText === null ? null : (
            <ul className="quick-search-result quick-search-result--empty">
                <li className="quick-search-result__item quick-search-result__group-header">
                    {result.emptyResultText}
                </li>
            </ul>
        )}
    </div>
);

export default QuickSearchResultEmpty;
